import { isDefaultExperimentRoute, type ExperimentAssignment } from './assignment.ts';
let assignment: ExperimentAssignment | undefined;
export function setExperimentAssignment(value: ExperimentAssignment | undefined): void { assignment = value; }
export function getExperimentAssignment(location: { pathname: string; hash: string }): ExperimentAssignment | undefined {
  return isDefaultExperimentRoute(location) ? assignment : undefined;
}
export function experimentProperties(location: { pathname: string; hash: string }): Record<string, string | boolean> {
  const a = getExperimentAssignment(location);
  if (!a) return {};
  return {
    ...(a.experimentId ? {experiment_id: a.experimentId, experiment_variant: a.variant} : {}),
    experiment_preview: a.preview, experiment_load_failed: a.loadFailed,
    ...(a.landerId ? {lander_id: a.landerId} : {}),
    ...(a.renderedLanderId ? {rendered_lander_id: a.renderedLanderId} : {}),
    ...(a.runId ? {lander_run_id: a.runId} : {}),
  };
}
